import ExportMessageWidgetActionComponent from "views/components/widgets/ExportWidgetAction/ExportMessageWidgetActionComponent";
import LogViewWidget from "logview/logic/LogViewWidget";
const ExportLogViewWidgetAction = {
  type: "export-log-view-widget-action",
  position: "menu",
  isHidden: (w) => w.type !== LogViewWidget.type,
  component: ExportMessageWidgetActionComponent
};
export default ExportLogViewWidgetAction;
